// Countdown Timer
const updateCountdown = (timer, countdown=null) => {
    let now = new Date().getTime();

    var ldate = timer.getAttribute('data-countdown-timer')
    ldate = ldate.split('/');
    if(ldate.length == 6){
        launchDate=ldate[1]+" "+ldate[0]+", "+ldate[2]+ " "+ldate[3]+":"+ldate[4]+":"+ldate[5];
    }

    launchDate = new Date(launchDate).getTime();
    let difference = launchDate - now;
    

    if (difference > 0) {
        let days = Math.floor(difference / (1000 * 60 * 60 * 24));
        let hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((difference % (1000 * 60)) / 1000);

        timer.querySelector('[data-countdown-value="days"]').innerHTML = days;
        timer.querySelector('[data-countdown-value="hours"]').innerHTML = hours;
        timer.querySelector('[data-countdown-value="minutes"]').innerHTML = minutes;
        timer.querySelector('[data-countdown-value="seconds"]').innerHTML = seconds;
    } else {
        if(!countdown) {
            return
        }
        clearInterval(countdown); // Stop the countdown if the launch date is passed
        timer.innerHTML = 'Countdown Expired';
    }
};


const initTimer = () => {
    const timers = document.querySelectorAll('.countdown-timer-simple');

    for (let i = 0; i < timers.length; i++) {
        // Update the countdown immediately when the page loads
        updateCountdown(timers[i]);

        // Update the countdown every second
        const countdown = setInterval(() => {
            updateCountdown(timers[i], countdown);
        }, 1000);
        
    }
}

const mountSlider = (sliderContainer) => {
    if (!sliderContainer || sliderContainer.dataset.sliderMounted === 'true') return;

    const sliderElement = sliderContainer.querySelector('.splide');
    if (!sliderElement) return;

    const options = JSON.parse(sliderContainer.getAttribute('data-options') || '{}');
    new Splide(sliderElement, options).mount();
    sliderContainer.dataset.sliderMounted = 'true';
}

const sliders = () => {
    const slides = document.querySelectorAll('.splides');

    for (let i = 0; i < slides.length; i++) {
        const collectionPanel = slides[i].closest('.collection-options__item');

        // Carousels in inactive collection tabs are mounted when their tab is selected.
        if (collectionPanel && !collectionPanel.classList.contains('custom-active')) continue;

        mountSlider(slides[i]);
    }
}

const selectors = () => {
    const selects = document.querySelectorAll('[data-show-group]');
    document.addEventListener('click', function(e) {
        if(e.target.hasAttribute('data-show-group') || e.target.closest('[data-show-group]')) {
            const group = e.target.hasAttribute('data-show-group') ? e.target.getAttribute('data-show-group') : e.target.closest('[data-show-group]').getAttribute('data-show-group');
            const selector = e.target.hasAttribute('data-show-selector') ? e.target.getAttribute('data-show-selector') : e.target.closest('[data-show-selector]').getAttribute('data-show-selector');

            // Target elements
            const elements = document.querySelectorAll(`${group}`);
            for (let i = 0; i < elements.length; i++) {
                if(elements[i].getAttribute('data-show-element') == selector) {
                    elements[i].classList.add('custom-active');
                    const inactiveSliders = elements[i].querySelectorAll('.splides');
                    for (let j = 0; j < inactiveSliders.length; j++) {
                        mountSlider(inactiveSliders[j]);
                    }
                } else {
                    elements[i].classList.remove('custom-active');
                }
            }

            // Target selectors
            const selectors = document.querySelectorAll(`[data-show-group="${group}"]`);
            for (let i = 0; i < selectors.length; i++) {
                if(selectors[i].getAttribute('data-show-selector') == selector) {
                    selectors[i].classList.add('custom-selector-active');
                } else {
                    selectors[i].classList.remove('custom-selector-active');
                }
            }

        }
    });

    for (let i = 0; i < selects.length; i++) {
        document.addEventListener('click', function() {
            if(selects[i].value == selects[i].dataset.showGroup) {
                document.querySelector(selects[i].dataset.showGroup).classList.remove('hidden');
            }
        });
    }
}

const customModals = () => {
    document.addEventListener('click', function(e) {
        if(e.target.getAttribute('data-custom-modal') || e.target.closest('[data-custom-modal]')) {
            const modal = e.target.getAttribute('data-custom-modal') ? e.target.getAttribute('data-custom-modal') : e.target.closest('[data-custom-modal]').getAttribute('data-custom-modal');
            document.querySelector(modal).classList.add('open');
        } else if(e.target.classList.contains('custom-modal-close') || e.target.closest('.custom-modal-close') || e.target.classList.contains('custom-modal-overlay')) {
            const modal = e.target.closest('.custom-modal');
            const video = modal.querySelector('video');
            if(video) {
                video.pause();
            }
            modal.classList.remove('open');
        }
    });
}

document.addEventListener('DOMContentLoaded', function() {
    initTimer();
    sliders();
    selectors();
    customModals();
});
